import React, { Component } from "react";
import Paper from "material-ui/Paper";
import {
  BrowserRouter as Router,
  Route,
  withRouter,
  Switch
} from "react-router-dom";
import Header from "./components/Header";
import routes from "./routes";
import Error404 from "./pages/404";
import "./App.css";

const HeaderWithRoute = withRouter(props => <Header {...props} />);

class App extends Component {
  render() {
    return (
      <Router>
        <div className="App">
          <Paper className={"wrapper"}>
            <HeaderWithRoute />
            <Switch>
              {routes.map((page, i) => (
                <Route
                  key={"route-" + i}
                  exact
                  path={page.path}
                  component={page.component}
                />
              ))}
              <Route component={Error404} />
            </Switch>
          </Paper>
        </div>
      </Router>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js